module.exports = __webpack_public_path__ + "img/chofu_restaurant_on.b764cd37.svg";